module.exports = __webpack_public_path__ + "static/img/pay-icon03.d67b553e.svg";